import { render, staticRenderFns } from "./default.vue?vue&type=template&id=6b8e1439&"
import script from "./default.vue?vue&type=script&lang=js&"
export * from "./default.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppAnnouncement: require('/opt/atlassian/pipelines/agent/build/frontend/apps/freelancer/components/layout/appAnnouncement.vue').default})
